import React from 'react';
import ReactSVG from 'react-svg';
import { FileIcon, DownloadIcon } from '~/assets/svgIcons';
import { FileInfoContainer, FileName, FileDetails } from './styles';

const getFileExtension = (contentType: string): string =>
  contentType
    .split('/')
    .pop()
    ?.toUpperCase() ?? contentType.toUpperCase();

interface FilePreviewProps {
  name: string;
  size: number;
  contentType: string;
  onDownload: React.MouseEventHandler<any>;
}

const FilePreview: React.FC<FilePreviewProps> = ({
  name,
  size,
  contentType,
  onDownload,
}) => (
  <>
    <ReactSVG src={FileIcon} className="icon-file" />

    <FileInfoContainer>
      <FileName title={name}>{name}</FileName>

      {contentType && (
        <FileDetails>
          {getFileExtension(contentType)}
          {size > 0 ? ` - ${Math.round(size / 1024)} KB` : ''}
        </FileDetails>
      )}
    </FileInfoContainer>

    <ReactSVG
      src={DownloadIcon}
      className="icon-download"
      onClick={onDownload}
    />
  </>
);

export default FilePreview;
